<template>
  <div>
    <div
      class="content-box"
      :style="{
        background: `url('${agentDownloadBackgroundUrl}') no-repeat`,
        backgroundSize: '100%',
      }"
    >
      <div
        @click="downApp"
        :style="{ background: color }"
        class="submit-btn anima"
      >
        <img class="img-style" src="@/assets/download.png" />
        <span class="text-style">立即下载</span>
      </div>
    </div>

    <van-overlay :show="show" @click="show = false">
      <div class="wrapper">
        <img class="block" src="@/assets/wx_android.png" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { getVersionApi } from "@/api/user.js";
import { getWXAuthInfor } from "@/api/home";
export default {
  data() {
    return {
      path: "",
      agentDownloadBackgroundUrl: "",
      color: "",
      agentBrandName: "",
      agentLogoUrl: "",
      show: false, //是否显示遮罩层
    };
  },
  mounted() {
    let agent = navigator.userAgent || navigator.vendor || window.opera;
    if (agent != null) {
      let agentName = agent.toLowerCase();
      if (/android/i.test(agentName) && /MicroMessenger/i.test(agentName)) {
        this.show = true;
      }
      if (/iphone/i.test(agentName)) {
        this.show = false;
      }
    }
    console.log(111111111, this.show);
    if (this.$route.query.brandId === "") {
      return;
    }
    getVersionApi({
      brandId: this.$route.query.brandId,
      clientType: this.checkPhone,
      appType: "A",
    }).then((res) => {
      this.path = res.path;
      this.agentDownloadBackgroundUrl = res.agentDownloadBackgroundUrl;
      this.color = res.agentThemeColor;
      this.agentBrandName = res.agentBrandName;
      this.agentLogoUrl = res.agentLogoUrl;

      //配置微信授权
      this.uppdateWXConfigAction();
    });
  },
  computed: {
    checkPhone() {
      let agent = navigator.userAgent || navigator.vendor || window.opera;
      if (agent != null) {
        let agentName = agent.toLowerCase();
        if (/android/i.test(agentName)) {
          return 1;
        }
        if (/iphone/i.test(agentName)) {
          return 2;
        }
        return 3;
      }
      return 3;
    },
  },
  methods: {
    //点击下载应用
    downApp() {
      window.location.href =
        this.checkPhone === 1
          ? this.path
          : "https://itunes.apple.com/cn/app/6746831693";
    },
    uppdateWXConfigAction() {
      getWXAuthInfor({ brandId: this.$route.query.brandId }).then((res) => {
        this.$wx.config({
          debug: false,
          appId: res.appId, // 必填，公众号的唯一标识
          timestamp: res.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.noncestr, // 必填，生成签名的随机串
          signature: res.signature, // 必填，签名
          jsApiList: ["updateAppMessageShareData"], // 必填，随意一个接口即可
        });

        this.$wx.ready(() => {
          console.log("微信JS-SDK初始化成功");
          this.$wx.updateAppMessageShareData({
            title: `<${this.agentBrandName}>App下载`, // 分享标题
            desc: "轻松搞定设备管理、团队管理、收益明细一目了然，立即下载App开始使用吧！", // 分享描述
            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: this.agentLogoUrl, // 分享图标
            success: function () {
              // 设置成功
            },
          });
        });

        this.$wx.error((err) => {
          console.error("wx.config 错误:", err);
        });
      });
    },
  },
};
</script>
<style lang="less" scoped>
.content-box {
  position: absolute;
  width: 100%;
  height: 100%;
  //background: #dff0fc url("../../assets/down/mer-bg.png") no-repeat;
  background-size: 100%;
}
.wrapper {
  display: flex;
  height: 100%;
  justify-content: flex-end;
  .block {
    width: 496px;
    height: 410px;
  }
}
.submit-btn {
  position: fixed;
  z-index: 1;
  bottom: 50px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 652px;
  height: 96px;
  border-radius: 96px 96px 96px 96px;
  display: flex;
  align-items: center;
  justify-content: center;
  .img-style {
    width: 36px;
    height: 36px;
  }
  .text-style {
    font-weight: bold;
    font-size: 32px;
    color: #ffffff;
    text-align: center;
    margin-left: 20px;
  }
}
.anima {
  animation-name: downBbut; // 动画名称
  animation-direction: alternate; // 动画在奇数次（1、3、5...）正向播放，在偶数次（2、4、6...）反向播放。
  animation-timing-function: linear; // 动画执行方式，linear：匀速；ease：先慢再快后慢；ease-in：由慢速开始；ease-out：由慢速结束；ease-in-out：由慢速开始和结束；
  animation-delay: 0s; // 动画延迟时间
  animation-iteration-count: infinite; //  动画播放次数，infinite：一直播放
  animation-duration: 1.5s; // 动画完成时间
}

@keyframes downBbut {
  0% {
    transform: translate(-50%, 0) scale(1);
  }
  25% {
    transform: translate(-50%, 0) scale(0.9);
  }
  50% {
    transform: translate(-50%, 0) scale(0.85);
  }
  75% {
    transform: translate(-50%, 0) scale(0.9);
  }
  100% {
    transform: translate(-50%, 0) scale(1);
  }
}
</style>
